import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'RecordPage',
      component: () => import('../views/RecordPage.vue'),
      meta: { title: '律高CRM录音' }
    },
    {
      path: '/company',
      name: 'CompanySelect',
      component: () => import('../views/Company.vue'),
      meta: { title: '公司选择' }
    },
    {
      path: '/room',
      name: 'RoomSelect',
      component: () => import('../views/Room.vue'),
      meta: { title: '谈案室选择' }
    }
  ]
})

export default router
